module.exports = __webpack_public_path__ + "img/Johann Espiritu.f92df564.jpg";